module.exports = __webpack_public_path__ + "fonts/MarkerFelt-Thin.d0d3a3b8.otf";